"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePageFocus;
var _react = require("react");
var _timeTracker = require("./time-tracker");
function usePageFocus(trackerEnabled) {
  const [pageFocussed, setPageFocussed] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    if (!trackerEnabled) return;
    const userLeft = () => setPageFocussed(false);
    const userReturned = () => setPageFocussed(true);
    const onVisibChange = () => document.hidden ? userLeft() : userReturned();
    const pageFocusEvents = [[document, "visibilitychange", onVisibChange], [window, "blur", userLeft], [window, "focus", userReturned]];
    (0, _timeTracker.handleListeners)("add", pageFocusEvents);
    return () => (0, _timeTracker.handleListeners)("remove", pageFocusEvents);
  }, [trackerEnabled]);
  return pageFocussed;
}